import { asyncRoutes, constantRoutes } from '@/router'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
    } else {
        return true
    }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
    const res = []
    routes.forEach(route => {
        const tmp = {...route }
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles)
            }
            res.push(tmp)
        }
    })
    return res
}

const state = {
    routes: [],
    addRoutes: [],
    currentRouteTitle: '',
    currentRouteHasBack: false
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = constantRoutes.concat(routes)
    },
    SET_CURRENT_ROUTE_TILE: (state, routeTitle) => {
        state.currentRouteTitle = routeTitle
    },
    SET_CURRENT_ROUTE_HAS_BACK: (state, hasBack) => {
        state.currentRouteHasBack = hasBack
    }
}

const actions = {
    generateRoutes({ commit }, roles) {
        return new Promise(resolve => {
            let accessedRoutes
            if (roles.includes('admin')) {
                accessedRoutes = asyncRoutes || []
            } else {
                accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
            }
            commit('SET_ROUTES', accessedRoutes)
            resolve(accessedRoutes)
        })
    },
    // updateRouteTitleChildren
    updateRouteTitleChildren({ commit }, routeInfo) {
        const { routeTitle, routeHasBack } = routeInfo
        return new Promise(resolve => {
            commit('SET_CURRENT_ROUTE_TILE', routeTitle)
            commit('SET_CURRENT_ROUTE_HAS_BACK', routeHasBack)
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/permission.js